// Derives the Data page's state from the portal's coverage payload.
//
// Coverage is one row per contract field; every field of an entity repeats that
// entity's row count in `total` (the same assumption ProvenanceCoverage makes).
// So an entity's row count is any of its rows' `total`, and a tenant "has data"
// as soon as one entity has rows.

const ENTITIES = ['companies', 'people', 'jobs'];

export function entityTotals(rows) {
  const totals = { companies: 0, people: 0, jobs: 0 };
  (rows || []).forEach((r) => {
    if (r && ENTITIES.includes(r.entity)) {
      totals[r.entity] = Math.max(totals[r.entity], Number(r.total) || 0);
    }
  });
  return totals;
}

export function hasData(rows) {
  const t = entityTotals(rows);
  return ENTITIES.some((e) => t[e] > 0);
}

// Which tab opens first. An empty tenant needs to import before anything else
// is meaningful, so admins land on the import flow. Everyone else lands on
// quality — non-admins cannot run imports at all (the portal's trigger floor is
// admin), so showing them the pipeline would be a dead end.
export function defaultTab({ hasData: hasRows, isAdmin }) {
  if (!isAdmin) return 'quality';
  return hasRows ? 'quality' : 'pipeline';
}

// A plain-language sentence of what landed, e.g.
// "13,601 companies, 127,883 people, 5,891 jobs". Entities that landed nothing
// are left out rather than shown as zeros.
export function importSummary(rows) {
  const t = entityTotals(rows);
  return ENTITIES.filter((e) => t[e] > 0)
    .map((e) => `${t[e].toLocaleString('en-US')} ${e}`)
    .join(', ');
}
